import React from "react";

/**
 * R6 B2 — Rep Leaderboard (full).
 */
export default function RepLeaderboardFull({ rows = [], onDrill }) {
  return (
    <div className="r6-analytics-block">
      <h3 className="r6-analytics-title">Rep Leaderboard</h3>
      <div className="r6-analytics-table-wrap">
        <table className="r6-analytics-table">
          <thead>
            <tr>
              <th>Rep</th>
              <th>Active</th>
              <th>Due</th>
              <th>Overdue</th>
              <th>Won</th>
              <th>Avg Time</th>
              <th>Resp %</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={7} className="r6-analytics-empty">No data</td></tr>
            )}
            {rows.map((r) => (
              <tr
                key={r.rep_id}
                className="r6-analytics-clickable"
                onClick={() => onDrill?.({ salesRep: r.rep_id })}
              >
                <td>{r.rep_name || `Rep ${r.rep_id}`}</td>
                <td>{r.active_leads}</td>
                <td>{r.due_next_count}</td>
                <td>{r.overdue_count}</td>
                <td>{r.won}</td>
                <td>{r.avg_completion_hours != null ? `${r.avg_completion_hours} h` : "—"}</td>
                <td>{r.completion_rate}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}